import { useMemo } from "react";

import type {
  WearablePathOverrideEntry,
  WearablePathOverrideSurface,
} from "@/lib/wearables/wearables.pathOverrideMemory";
import type { WearablePathTrack } from "@/lib/wearables/wearables.pathDefaults";
import { useWearablesStore } from "@/state/wearables/useWearablesStore";

export function useWearablePathOverrideMemory(
  surface: WearablePathOverrideSurface,
) {
  const overrideEntry = useWearablesStore(
    (state) => state.pathAwareOverrides?.[surface] ?? null,
  );
  const setPathAwareOverride = useWearablesStore(
    (state) => state.setPathAwareOverride,
  );
  const clearPathAwareOverride = useWearablesStore(
    (state) => state.clearPathAwareOverride,
  );

  return useMemo(
    () => ({
      overrideEntry,
      pinTrack: (track: WearablePathTrack) =>
        setPathAwareOverride(surface, {
          mode: "pinned",
          track,
          updatedAt: new Date().toISOString(),
        } satisfies WearablePathOverrideEntry),
      dismiss: () =>
        setPathAwareOverride(surface, {
          mode: "dismissed",
          updatedAt: new Date().toISOString(),
        } satisfies WearablePathOverrideEntry),
      reset: () => clearPathAwareOverride(surface),
    }),
    [clearPathAwareOverride, overrideEntry, setPathAwareOverride, surface],
  );
}

export default useWearablePathOverrideMemory;